import { ICriteriaDetails } from "./criteriaDetails";

export enum CriteriaMethodEnum {
    AND = "and",
    OR = "or",
    NOT = "not",
}

export interface ICriteria {
    id?: number;
    criteria_group_id: number;
    method: CriteriaMethodEnum;
    description: string;
    criteria_details: ICriteriaDetails[];
} 